import { ReferentialKey } from 'api/referential';

/**
 * Les adresses legacy stockent parfois le libellé du pays (« France ») au lieu
 * du code ISO (« FR ») attendu par la validation et le back. FormikDropdown
 * fait ce fallback libellé→code, mais uniquement quand le champ est monté —
 * les adresses des contacts d'une personne morale (stockées dans le tableau
 * Formik, sans champ monté) doivent être normalisées dès le mapping.
 * Valeur inconnue du référentiel : renvoyée telle quelle (pas de perte de donnée).
 */
export function normalizeCountryCode(
  value: string | null | undefined,
  referentialsData: any
): string {
  if (!value) return '';
  const countries = referentialsData?.[ReferentialKey.Country] ?? [];
  if (countries.some((item: any) => item.code === value)) return value;
  return countries.find((item: any) => item.label === value)?.code ?? value;
}
